import clsx from 'clsx';

export function CheckIcon({ className }) {
  return (
    <svg
      className={clsx(className)}
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M0.623047 5.57071L5.12305 9.16162L12.623 0.661621"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
}
